
import React from 'react';
import { IconProps } from './IconProps';

const SmartpayIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
    <path d="M12 15a2 2 0 0 0 2-2H10a2 2 0 0 0 2 2z"/>
  </svg>
);

export default SmartpayIcon;
